export default __webpack_public_path__ + "static/media/training.1475e5f6.png";